<template>
  <div class="database-container">
    <a-card class="content-card">
      <div class="page-header">
        <div class="header-icon">
          <a-icon type="cloud-server" />
        </div>
        <div class="header-text">
          <h2 class="page-title">{{ translate('static.nativeStaticPurchase') }}</h2>
          <p class="page-description">{{ translate('static.pleaseFillInfo') }}</p>
        </div>
      </div>
      <a-form :model="formData" :rules="rules" ref="form" layout="vertical" @submit.prevent="onSubmit" @reset="onReset" class="form-container">
        <a-form-item :label="translate('static.businessType')" name="purposeWeb" class="form-section">
          <a-radio-group v-model="formData.purposeWeb" @change="changePurposeWeb" class="business-type-group">
            <a-radio-button 
              v-for="item in businessTypes" 
              :key="item.value" 
              :value="item.value" 
              class="business-type-btn"
            >{{ item.label }}</a-radio-button>
          </a-radio-group>
          <div class="form-note">
            <span class="note-icon">💡</span>
            {{ translate('static.businessTypeNote') }}
          </div>
        </a-form-item>
        
        <div class="form-row">
          <a-form-item :label="translate('static.country')" name="country" class="form-col">
            <a-select 
              v-if="mounted"
              v-model="formData.country" 
              :placeholder="translate('static.pleaseSelectCountry')"
              @change="changeCountry" 
              show-search
              filterable
              :dropdown-match-selecto-width="false"
              class="form-select"
            >
              <a-select-option
                v-for="(item, index) in countryOptions"
                :value="item.countryCode || ''"
                :key="'country-' + (item.id || item.countryCode || index)"
                class="form-option"
              >{{ currentLanguage === 'zh' ? (item.countryZh || item.country || '') : (item.country || '') }}</a-select-option>
            </a-select>
          </a-form-item>
          
          <a-form-item :label="translate('static.city')" name="cityName" class="form-col">
            <div class="city-select-container">
              <div class="city-select-with-loading">
                <a-select
                  v-if="mounted"
                  v-model="formData.cityName"
                  :placeholder="translate('static.pleaseSelectCity')"
                  clearable
                  filterable
                  @change="changeCity"
                  :dropdown-match-selecto-width="false"
                  class="form-select"
                  :loading="loading"
                >
                  <a-select-option
                    v-for="(item, index) in cityOptions"
                    :value="item.city_name || ''"
                    :key="'city-' + (item.city_name || index)"
                    class="form-option"
                  >{{ item.city_name || '' }}</a-select-option>
                </a-select>
                <a-spin v-if="loading" :style="{ marginLeft: '10px', alignSelf: 'center' }" size="small"></a-spin>
              </div>
              <span class="inventory-info">
                {{ translate('static.inventory') }}: <span class="inventory-value">{{ Inventory }}</span>
              </span>
            </div>
          </a-form-item>
        </div>
        
        <a-form-item :label="translate('static.protocol')" name="agree">
          <a-radio-group v-model="formData.protocolsType">
            <a-radio-button value="1">{{ translate('static.http') }}</a-radio-button>
            <a-radio-button value="2">{{ translate('static.socks5') }}</a-radio-button>
          </a-radio-group>
          <div class="form-note">
            <span class="note-icon">💡</span>
            {{ translate('static.protocolNote') }}
          </div>
        </a-form-item>
        
        <a-form-item :label="translate('static.purchaseDuration')" name="timelen">
          <a-radio-group v-model="formData.timePeriod" @change="changeTimelen">
            <a-radio-button value="30">{{ translate('static.thirtyDays') }}</a-radio-button>
          </a-radio-group>
          <div class="form-note">
            <span class="note-icon">💡</span>
            {{ translate('static.durationNote') }}
          </div>
        </a-form-item>
        
        <a-form-item :label="translate('static.purchaseQuantity')" name="count">
          <a-input-number 
            :min="1" 
            :max="300"  
            v-model="formData.count" 
            :placeholder="translate('static.purchaseQuantity')" 
            @change="changeNum"
          />
        </a-form-item>
        
        <a-form-item :label="translate('static.paymentAmount')" name="paynumber">
          <p style="color: #dd8681; font-weight: 600">{{ totalPrice }}{{ translate('static.integral') }}</p>
        </a-form-item>
        
        <a-form-item :label="translate('static.availableIntegral')" name="interval">
          <span style="color: #dd8681; font-weight: 600;">({{ interval?.payIntegral || 0 }}{{ translate('static.rechargeIntegral') }}</span>
          <span style="color: #dd8681; font-weight: 600; margin: 0 20px">{{ interval?.giveIntegral || 0 }}{{ translate('static.giftIntegral') }}</span>
          <span style="color: #dd8681; font-weight: 600;">{{ translate('static.prioritizeRecharge') }})</span>
        </a-form-item>
        
        <a-form-item :style="{marginLeft: isMobile ? '-1rem' : '100px'}">
          <div style="display: flex; gap: 50px; justify-content: center">
            <a-button type="primary" html-type="submit" :style="{width: isMobile ? '130px' : '200px'}" class="action-btn">
              {{ translate('static.pay') }}
            </a-button>
            <a-button type="default" @click="onReset" :style="{width: isMobile ? '130px' : '200px'}" class="action-btn">
              {{ translate('static.reset') }}
            </a-button>
          </div>
        </a-form-item>
      </a-form>
      
      <a-modal 
        :title="translate('static.confirmOrder')" 
        :visible="visible" 
        width="40%" 
        @ok="onConfirmadd" 
        @cancel="onCloseadd"
      >
        <div><p>{{ translate('static.confirmPurchase') }}</p></div>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
const INITIAL_DATA = {
  timePeriod: '',
  protocolsType: '',
  cityName: '',
  country: '',
  count: 1,
  purposeWeb: '',
};

export default {
  name: 'StaticNativePurchase',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
  },
  data() {
    return {
      formData: { ...INITIAL_DATA },
      rules: {
        country: [{ required: true, message: '国家必填', trigger: 'change' }],
        cityName: [{ required: true, message: '城市必填', trigger: 'change' }],
        protocolsType: [{ required: true, message: '请选择协议', trigger: 'change' }],
        purposeWeb: [{ required: true, message: '请选择需要的业务类型', trigger: 'change' }],
        count: [{ required: true, message: '请选择购买数量', trigger: 'change' }],
      },
      countryOptions: [],
      cityOptions: [],
      aprice: 0,
      integral: 0,
      totalPrice: 0,
      numprice: 0,
      interval: {},
      visible: false,
      debounce: true,
      iso: 'US',
      Inventory: 0,
      isNtt: false,
      isMobile: false,
      mounted: false,
      loading: false, // 添加loading状态
      businessTypes: [
        { value: 'TikTok', label: 'Tiktok' },
        { value: 'web3', label: 'web3' },
        { value: 'Shopee', label: 'Shopee' },
        { value: 'Etsy', label: 'Etsy' },
        { value: 'Amazon', label: 'Amazon' },
        { value: 'Temu', label: 'Temu' },
        { value: 'Facebook', label: 'Facebook' },
        { value: 'Linkedin', label: 'Linkedin' },
        { value: 'ticket', label: 'ticket' },
        { value: 'Ebay', label: 'eBay' },
        { value: 'YouTube', label: 'YouTube' },
        { value: 'other', label: 'other' }
      ]
    };
  },
  mounted() {
    this.mounted = true;
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.checkMobile);
    this.getCountry();
    this.$nextTick(() => {
      this.getInterval();
    });
    this.onResetStart();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'static.nativeStaticPurchase': lang === 'zh' ? '原生静态代理购买' : 'Native Static Proxy Purchase',
        'static.pleaseFillInfo': lang === 'zh' ? '请填写以下信息进行代理购买' : 'Please fill in the following information for proxy purchase',
        'static.businessType': lang === 'zh' ? '业务类型' : 'Business Type',
        'static.country': lang === 'zh' ? '国家' : 'Country',
        'static.city': lang === 'zh' ? '城市' : 'City',
        'static.protocol': lang === 'zh' ? '协议' : 'Protocol',
        'static.purchaseDuration': lang === 'zh' ? '购买时长' : 'Purchase Duration',
        'static.purchaseQuantity': lang === 'zh' ? '购买数量' : 'Purchase Quantity',
        'static.paymentAmount': lang === 'zh' ? '支付金额' : 'Payment Amount',
        'static.availableIntegral': lang === 'zh' ? '可用积分' : 'Available Integral',
        'static.pay': lang === 'zh' ? '支付' : 'Pay',
        'static.reset': lang === 'zh' ? '重置' : 'Reset',
        'static.confirmOrder': lang === 'zh' ? '确认订单' : 'Confirm Order',
        'static.confirmPurchase': lang === 'zh' ? '确定要购买当前套餐吗' : 'Confirm purchase of the current package?',
        'static.http': lang === 'zh' ? 'Http' : 'Http',
        'static.socks5': lang === 'zh' ? 'Socks5' : 'Socks5',
        'static.thirtyDays': lang === 'zh' ? '30天' : '30 Days',
        'static.integral': lang === 'zh' ? '积分' : 'Integral',
        'static.rechargeIntegral': lang === 'zh' ? '充值积分' : 'Recharge Integral',
        'static.giftIntegral': lang === 'zh' ? '赠送积分' : 'Gift Integral',
        'static.prioritizeRecharge': lang === 'zh' ? '优先使用充值积分' : 'Prioritize recharge integral',
        'static.businessTypeNote': lang === 'zh' ? '购买前请先确认您的业务类型，避免购买后无法使用的情况' : 'Please confirm your business type before purchase to avoid usage issues',
        'static.protocolNote': lang === 'zh' ? '同时支持Http、Https、Socks5协议，保持默认即可' : 'Supports Http, Https, Socks5 protocols, default is fine',
        'static.durationNote': lang === 'zh' ? '有效时长，到期续费即可' : 'Valid duration, renewal available upon expiration',
        'static.inventory': lang === 'zh' ? '库存' : 'Inventory',
        'static.pleaseSelectCountry': lang === 'zh' ? '请选择国家' : 'Please select country',
        'static.pleaseSelectCity': lang === 'zh' ? '请选择城市' : 'Please select city'
      };
      return translations[key] || key;
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    getInterval() {
      this.$request.get('/userIntegral/selectUserIntegral').then((res) => {
        if (res.data.code === 200) {
          this.interval = res.data.data;
        }
      });
    },
    getCountry() {
      this.$request.get('/userIntegral/getNuxCountryList').then((res) => {
        if (res && res.data && res.data.code === 200) {
          this.countryOptions = res.data.data || [];
          this.countryOptionsLoaded = true;
          console.log('countryOptions:', this.countryOptions);
        } else {
          this.countryOptions = [];
          this.countryOptionsLoaded = true;
          console.error('获取国家列表失败:', res);
        }
      }).catch((error) => {
        this.countryOptions = [];
        this.countryOptionsLoaded = true;
        console.error('获取国家列表出错:', error);
      });
    },
    changePurposeWeb(e) {
      if (this.formData.country === '') {
        return;
      }
      this.loading = true; // 开始loading
      this.$request
        .get(
          `/userIntegral/getNuxCityList?country_code=${this.formData.country}&proxies_format=${2}&proxies_type=` +
          `Premium (ISP) proxies` +
          `&purpose_web=${e.target.value}`,
        )
        .then((res) => {
          if (res && res.data && res.data.code === 200 && res.data.data && res.data.data.Data) {
            this.cityOptions = res.data.data.Data.country_list || [];
            this.cityOptionsLoaded = true;
            console.log('cityOptions from changePurposeWeb:', this.cityOptions);
            this.changeCity(this.formData.cityName);
          } else {
            this.cityOptions = [];
            this.cityOptionsLoaded = true;
            console.error('获取城市列表失败:', res);
          }
        }).catch((error) => {
          this.cityOptions = [];
          this.cityOptionsLoaded = true;
          console.error('获取城市列表出错:', error);
        }).finally(() => {
          this.loading = false; // 结束loading
        });
    },
    changeCountry(e) {
      if (this.formData.purposeWeb === '') {
        this.formData.country = '';
        this.$message.warning('请选择业务类型');
        return;
      }
      this.formData.cityName = null;
      this.iso = e;
      this.totalPrice = 0;
      this.formData.count = '1';
      this.formData.cityName = '';
      this.formData.timePeriod = '';
      this.aprice = 0;
      this.integral = 0;
      
      // 查找当前选择的国家
      const selectedCountry = this.countryOptions.find(item => item.countryCode === e);
      if (selectedCountry) {
        this.loading = true; // 开始loading
        this.$request
          .get(
            `/userIntegral/getNuxCityList?country_code=${selectedCountry.countryCode}&proxies_format=${2}&proxies_type=` +
            `Premium (ISP) proxies` +
            `&purpose_web=${this.formData.purposeWeb}`,
          )
          .then((res) => {
            if (res && res.data && res.data.code === 200 && res.data.data && res.data.data.Data) {
              this.cityOptions = res.data.data.Data.country_list || [];
              this.cityOptionsLoaded = true;
              console.log('cityOptions from changeCountry:', this.cityOptions);
            } else {
              this.cityOptions = [];
              this.cityOptionsLoaded = true;
              console.error('获取城市列表失败:', res);
            }
          }).catch((error) => {
            this.cityOptions = [];
            this.cityOptionsLoaded = true;
            console.error('获取城市列表出错:', error);
          }).finally(() => {
            this.loading = false; // 结束loading
          });
      }
    },
    changeCity(e) {
      console.log('changeCity called with e:', e);
      this.Inventory = 0;
      if (e && this.cityOptions && Array.isArray(this.cityOptions)) {
        const selectedCity = this.cityOptions.find(item => item.city_name === e);
        if (selectedCity) {
          this.Inventory = selectedCity.number || 0;
        }
        if(e.includes('NTT')){
          this.isNtt = true;
          this.totalPrice = '900';
        } else {
          this.isNtt = false;
          this.totalPrice = '600';
        }
      }
      console.log('changeCity result - Inventory:', this.Inventory, 'isNtt:', this.isNtt, 'totalPrice:', this.totalPrice);
    },
    changeTimelen(e) {
      if (e == 30) {
        if(this.isNtt){
          this.totalPrice = '900';
        }else{
          this.totalPrice = '600';
        }
      }
    },
    changeNum(e) {
      this.numprice = e;
      if(this.isNtt){
        this.totalPrice = '900';
      }else{
        this.totalPrice = '600';
      }
      this.totalPrice = Number(this.numprice) * Number(this.totalPrice);
    },
    onReset() {
      // 手动重置表单字段，避免使用可能有问题的 resetFields() 方法
      this.totalPrice = 0;
      this.formData = { ...INITIAL_DATA };
      this.cityOptions = [];
      this.aprice = 0;
      this.integral = 0;
    },
    onResetNew() {
      this.totalPrice = 0;
      this.numprice = 1;
      this.formData.count = '1';
      this.formData.country = '';
      this.formData.cityName = '';
      this.formData.timePeriod = '';
      this.aprice = 0;
      this.integral = 0;
    },
    onResetStart() {
      this.totalPrice = 0;
      this.formData.count = '1';
      this.formData.country = '';
      this.formData.cityName = '';
      this.formData.timePeriod = '';
      this.formData.purposeWeb = '';
      this.aprice = 0;
      this.integral = 0;
    },
    onSubmit() {
      // 简化的表单验证，直接检查必填字段
      const { purposeWeb, country, cityName, protocolsType, count } = this.formData;
      
      if (!purposeWeb) {
        this.$message.warning('请选择需要的业务类型');
        return;
      }
      if (!country) {
        this.$message.warning('国家必填');
        return;
      }
      if (!cityName) {
        this.$message.warning('城市必填');
        return;
      }
      if (!protocolsType) {
        this.$message.warning('请选择协议');
        return;
      }
      if (!count || count < 1) {
        this.$message.warning('请选择购买数量');
        return;
      }
      
      // 验证通过，显示模态框
      this.visible = true;
    },
    onConfirmadd() {
      if (!this.debounce) {
        this.$message.error('请勿重复提交');
        return;
      }

      this.debounce = false;

      if(this.isNtt){
        this.formData.price = 900;
      }else{
        this.formData.price = 600;
      }

      this.$request.post('/userIntegral/purchaseStaticPackageNux', { ...this.formData }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('支付成功');
          // 支付成功后刷新表单
          this.onReset();
        } else {
          this.$message.error('创建静态套餐失败,请联系管理员~');
        }
      }).catch(error => {
        console.error('请求出错:', error);
        this.$message.error('网络请求异常，请稍后重试');
      }).finally(() => {
        this.visible = false;
        // 防止重复点击，3秒后恢复可点击状态
        setTimeout(() => {
          this.debounce = true;
        }, 3000);
      });
    },
    onCloseadd() {
      this.visible = false;
      this.debounce = true;
    },
  }
};
</script>

<style scoped lang="less">
/* 基础容器 - 与其他页面保持一致 */
.database-container {
  padding: 24px;
  background: #f5f5f5;
  min-height: 100%;
}

/* 内容卡片 - 与其他页面保持一致 */
.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: #fff;
  border: 1px solid #f0f0f0;
  padding: 24px;
}

/* 页面头部 */
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 28px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
  border-bottom: none;
}

.header-icon {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    font-size: 28px;
    color: #fff;
  }
}

.header-text {
  flex: 1;
}

.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px 0;
  letter-spacing: 0.5px;
}

.page-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  line-height: 1.6;
}

/* 表单容器 */
.form-container {
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 20px;
  background: transparent;
  border-radius: 0;
  border: none;
  box-shadow: none;
  transition: all 0.3s ease;
}

/* 表单标签样式 - 与其他页面保持一致 */
:deep(.ant-form-item-label > label) {
  font-size: 14px;
  font-weight: 600;
  color: #595959;
  letter-spacing: 0.5px;
  padding: 0 0 8px 0;
}

/* 输入框和选择框 - 与其他页面保持一致 */
:deep(.ant-select-selector),
:deep(.ant-input),
:deep(.ant-input-number) {
  height: 36px !important;
  line-height: 36px !important;
  border-radius: 6px !important;
  border-color: #d9d9d9 !important;
  
  &:focus,
  &:hover {
    border-color: #1890ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }
}

:deep(.ant-input-number-input-wrap input) {
  height: 36px !important;
  line-height: 36px !important;
}

/* 表单分段样式 */
.form-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

/* 业务类型分组 */
.business-type-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

/* 业务类型按钮 */
.business-type-btn {
  border-radius: 8px !important;
  margin-right: 8px !important;
  margin-bottom: 8px !important;
  padding: 0 20px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: #595959 !important;
  transition: all 0.3s ease !important;
  
  &:hover {
    background: #e6f7ff !important;
    border-color: #91d5ff !important;
    color: #1890ff !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
  }
  
  &.ant-radio-button-wrapper-checked {
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%) !important;
    border-color: #1890ff !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
    
    &:hover {
      background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%) !important;
      border-color: #40a9ff !important;
      color: #ffffff !important;
    }
  }
}

/* 表单说明文本 */
.form-note {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8c8c8c;
  background: #fafafa;
  padding: 10px 16px;
  border-radius: 8px;
  border-left: 3px solid #faad14;
  margin-top: 12px;
  line-height: 1.5;
  
  .note-icon {
    font-size: 16px;
  }
}

/* 所有单选按钮样式 */
:deep(.ant-radio-button-wrapper) {
  border-radius: 8px !important;
  margin-right: 8px !important;
  margin-bottom: 8px !important;
  padding: 0 20px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  background: #f5f5f5 !important;
  border: 1px solid #d9d9d9 !important;
  color: #595959 !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  z-index: 1 !important;
  
  /* 移除相邻按钮的左边框 */
  &:not(:first-child) {
    margin-left: 0 !important;
  }
  
  /* 移除默认的伪类边框 */
  &::before {
    display: none !important;
  }
  
  &:hover {
    background: #e6f7ff !important;
    border-color: #91d5ff !important;
    color: #1890ff !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
    z-index: 2 !important;
  }
  
  &.ant-radio-button-wrapper-checked {
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%) !important;
    border-color: #1890ff !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
    z-index: 2 !important;
    
    &:hover {
      background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%) !important;
      border-color: #40a9ff !important;
      color: #ffffff !important;
    }
  }
  
  /* 移除分组样式影响 */
  &-group {
    box-shadow: none !important;
  }
}

/* 按钮样式 - 与其他页面保持一致 */
.action-btn {
  height: 36px;
  font-size: 14px;
  font-weight: 600;
  padding: 0 32px;
  border-radius: 8px !important;
  line-height: 36px !important;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}

/* 支付金额样式 */
:deep(.ant-form-item-control) {
  & > span {
    font-size: 14px;
    color: #595959;
  }
}

/* 库存信息样式 */
.inventory-info {
  font-size: 14px;
  color: #ff4d4f;
  font-weight: 600;
  margin-left: 16px;
  vertical-align: middle;
}

/* 模态框样式优化 */
:deep(.ant-modal-header) {
  border-radius: 12px 12px 0 0 !important;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
}

:deep(.ant-modal-content) {
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

:deep(.ant-modal-title) {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}

/* 表单行布局 */
.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 16px;
}

/* 表单列布局 */
.form-col {
  flex: 1;
  min-width: 250px;
  flex: 1;
  min-width: 250px;
}

/* 表单选择框 */
.form-select {
  width: 100%;
  transition: all 0.3s ease;
}

/* 城市选择容器 */
.city-select-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 城市选择带loading容器 */
.city-select-with-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

/* 确保select组件占满容器 */
.city-select-with-loading .form-select {
  flex: 1;
}

/* 库存信息 */
.inventory-info {
  font-size: 14px;
  color: #8c8c8c;
  font-weight: 500;
  white-space: nowrap;
}

.inventory-value {
  color: #ff4d4f;
  font-weight: 600;
  font-size: 15px;
}

/* 支付金额样式 */
.payment-info {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  background: linear-gradient(135deg, #f6ffed, #f0f5ff);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e6f7ff;
  margin: 16px 0;
}

.payment-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.payment-label {
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 500;
}

.payment-value {
  font-size: 24px;
  font-weight: 700;
  color: #ff4d4f;
}

.available-integral {
  color: #52c41a;
  font-size: 16px;
  font-weight: 600;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .database-container {
    padding: 16px;
  }
  
  .content-card {
    padding: 16px;
  }
  
  .page-header {
    padding: 20px 24px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .header-icon {
    width: 48px;
    height: 48px;
    
    .anticon {
      font-size: 24px;
    }
  }
  
  .page-title {
    font-size: 22px;
  }
  
  .form-container {
    padding: 16px;
    max-width: 100%;
  }
  
  .form-row {
    flex-direction: column;
    gap: 16px;
  }
  
  .form-col {
    min-width: 100%;
  }
  
  .business-type-group {
    flex-direction: column;
  }
  
  .business-type-btn {
    margin-right: 0 !important;
    width: 100%;
  }
  
  .city-select-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .inventory-info {
    margin-left: 0 !important;
  }
  
  .payment-info {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .action-btn {
    padding: 0 20px;
    width: 100%;
  }
}
</style>